'use strict';
import angular from 'angular';

export default class AppStoryboardController {
  /*@ngInject*/
  constructor($stateParams, $http, $timeout, $state, Application, $scope, $filter, Auth, appConfig, Traduction) {
    var vm = this;
    vm.loading = true;

    var config = {}
    vm.Traduction = Traduction;

    Auth.getCurrentUser().then(function(user){
      vm.isAdmin = Auth.isAdminSync();
      $http.get('/api/applications/' + $stateParams.id).then(function(res) {
        var data = res.data;
        vm.autorisations = data.User.autorisations
        Application.load($stateParams.id).then(function() {
          $scope.$apply(function() {
            if(!Application.share.email.from) Application.share.email.from = Application.general.name;
            if(!Application.share.email.subject) Application.share.email.subject = Application.general.name + ' : Votre photo';
            if(!vm.autorisations.collecte || (!vm.autorisations.collecte.active && Application.general.storyboard[1].status)) Application.general.storyboard[1].status = false;
            if(!vm.autorisations.partage || (!vm.autorisations.partage.active && Application.general.storyboard[7].status)) Application.general.storyboard[7].status = false;
            if(!vm.autorisations.impression || (!vm.autorisations.impression.active && Application.general.storyboard[8].status)) Application.general.storyboard[8].status = false;
            if(!vm.autorisations.modes[Application.general.mode.value].active) Application.general.mode.value = _.findKey(vm.autorisations.modes, ['active', true]);
            vm.app = Application;

            setTimeout(function() {
              $('.selectpicker').selectpicker('refresh');
            }, 10);

            initSummernote();

            vm.show = function(elem) {
              if(elem == 'horizontalAlignement' && vm.app.general.mode.properties) return (((vm.app.general.mode.properties.position != 'horizontal' && vm.app.general.mode.number == 2) || (vm.app.general.mode.properties.position != 'vertical' && vm.app.general.mode.number == 3)) && vm.app.general.mode.number != 4)
              if(elem == 'verticalAlignement' && vm.app.general.mode.properties) return (((vm.app.general.mode.properties.position != 'vertical' && vm.app.general.mode.number == 2) || (vm.app.general.mode.properties.position != 'horizontal' && vm.app.general.mode.number == 3)) && vm.app.general.mode.number != 4)
            }
            vm.loading = false;
          });
        });
      }, function(error) {
        if (error.status == "404") {
          $state.go('application_main');
        }
        console.log(error);
      });
    })

    function initSummernote(){
      var addPicture = function (context) {
        var ui = $.summernote.ui;
        var button = ui.button({
          contents: '<i class="fa fa-camera"/>',
          tooltip: $filter('translate')('insertPicture'),
          click: function () {
            $('#editor').summernote('insertImage', 'assets/img/photo.png', function ($image) {
              $image.css('width', $image.width() / 3);
              $image.attr('id', 'bfast-picture');
            });
          }
        });
        return button.render();
      }

      $('#editor').summernote({
        toolbar : [
          ['misc', ['undo', 'redo', 'codeview']],
          ['style', ['bold', 'italic', 'clear']],
          ['fontsize', ['fontsize']],
          ['color', ['color']],
          ['insert', ['picture']],
          ['mybutton', ['addPic']]
        ],
        buttons: {
          addPic: addPicture
        },
        callbacks: {
          onInit: function() {
            $('#editor').summernote('code', vm.app.share.email.message);
          },
          onChange:_.debounce((contents, $editable) => {
              vm.app.share.email.message = contents;
            }, 250)
          }
      });
    }

    config.facebook = appConfig.facebook;

    window.fbAsyncInit = function() {
      FB.init({
        appId            : config.facebook.appId,
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v2.10'
      });
    };
    var facebookReady = false;
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/all.js";
      fjs.parentNode.insertBefore(js, fjs);
      facebookReady = true;
    }(document, 'script', 'facebook-jssdk'));

    vm.facebookLogin = function(){
        vm.facebook = {}
        FB.getLoginStatus(function(response) {
          if (response.status === 'connected') {
            fetchUser(response.authResponse.accessToken)
          }
          else {
            FB.login(function(response){
              console.log(response)
              if (response.status == 'connected') {
                fetchUser(response.authResponse.accessToken)
              }
              else {
                console.log('aborted')
              }
            }, {scope:'manage_pages,pages_show_list,publish_pages'});
          }
        });
    }

    vm.facebookLogout = function(){
      FB.logout(function(response) {
        vm.facebook = {}
        $scope.$apply()
      });
    }

    vm.selectPage = function(page){
      vm.selectedPage = page
      config.facebook.accessToken = vm.selectedPage.access_token
      $http.post('api/applications/getFacebookToken', config.facebook).then(function(response){
        console.log(response)
        Application.share.facebook.pageId = vm.selectedPage.id
        Application.share.facebook.pageName = vm.selectedPage.name
        Application.share.facebook.access_token = response.data.access_token
        Application.share.facebook.tokenExpireDuration = response.data.expires_in
        Application.share.facebook.createdAt = new Date
      })
    }

    vm.twitterLogin = function(){
      vm.twitter = {}
      window.open('/auth/twitter/', "_blank", "channelmode=yes,toolbar=no,scrollbars=yes,resizable=0,top=500,left=500,width=400,height=400");
    }

    vm.twitterLogout = function(){
      vm.twitter = {}
      Application.share.twitter.oauth_token = undefined;
      Application.share.twitter.oauth_verifier = undefined;
    }

    window.TwitterLoginCallback = function(){
      console.log('success', arguments)
      vm.twitter.connected = true;
      Application.share.twitter.oauth_token = arguments[0].oauth_token;
      Application.share.twitter.oauth_verifier = arguments[0].oauth_verifier;
      $scope.$apply();
    }

    $scope.$watch('vm.app.share.twitter.active', function(newV, oldV){
      if((newV == true && newV != oldV) && vm.app.share.twitter.oauth_token) {
        vm.twitter = {connected : true};
      }
    })

    function fetchUser(accessToken){
      FB.api('/me', {access_token : accessToken,fields: 'last_name,name,picture'}, function(response) {
        console.log(response);
        vm.facebook = response
        FB.api('/me/accounts', {
          access_token : accessToken,
          fields: 'picture{url},access_token,name,id'
        }, function(response){
          vm.facebook.pages =  response.data
          vm.selectedPage = _.find(vm.facebook.pages, ['id', Application.share.facebook.pageId])
          if(vm.selectedPage == undefined) vm.selectPage(vm.facebook.pages[0])
          vm.facebook.connected = true
          $scope.$apply()
        });
      });
    }

    $scope.$watch('vm.app.share.facebook.active', function(newV, oldV){
      if(facebookReady && newV == true && newV != oldV) {
        vm.facebookLogin()
      }
    })

    $scope.$watch('vm.app.general.mode.number', function(newV, oldV){
      if(newV != oldV) {
        if(newV == 4) vm.app.general.mode.properties.position = 'full';
        if(oldV == 4) vm.app.general.mode.properties.position = 'horizontal';
      }

    })

    $scope.$watch('vm.app.general.mode.value', function(newMode){
      if(newMode == 'boomerang' || newMode == 'gif') {
        vm.printDisabled = true;
        vm.filterDisabled = true;
        _.find(vm.app.general.storyboard, ['name', 'filter']).status = false;
        _.find(vm.app.general.storyboard, ['name', 'quantity']).status = false;
        vm.app.general.mode.number = 5;
      } else if(newMode == 'boomerang') {
        vm.greenBackgroundDisabled = true;
        vm.app.general.mode.greenBackground = false;
      } else if(newMode == 'multipose') {
        vm.app.general.mode.number = 2;
        vm.printDisabled = false;
        vm.filterDisabled = false;
        _.find(vm.app.general.storyboard, ['name', 'filter']).status = false;
      } else if(newMode == 'greenBackground') {
        vm.printDisabled = false;
        vm.filterDisabled = false;
        _.find(vm.app.general.storyboard, ['name', 'filter']).status = false;
      } else {
        vm.printDisabled = false;
        vm.filterDisabled = false;
        vm.greenBackgroundDisabled = false;
      }
    })

    vm.selectLangue = function(langue) {
      $http.get('/api/miscs/lang?lang=' + langue.libelle).then(function(resp){
      })
    }

    $scope.$watch('vm.app.general.languages.list',function(newV, oldV){
      console.log(newV)
      if(!vm.app) return
      vm.selectedLanguages = []
      _.map(vm.app.general.languages.list, function(o){
        vm.selectedLanguages.push(_.find(vm.Traduction.langues, ['libelle', o]))
      })
      if(!_.map(vm.selectedLanguages, 'libelle').includes(JSON.parse(vm.app.general.languages.selected).libelle)) {
        vm.app.general.languages.selected = vm.selectedLanguages[0];
        vm.app.general.languages.selected = _.find(vm.selectedLanguages, ['libelle', vm.app.general.languages.selected.libelle])
      } 
    })

    vm.save = function() {
      if(vm.facebook && !vm.facebook.name) Application.share.facebook.active = false;
      if(!vm.app.general.languages.multiple && vm.app.general.languages.list) vm.app.general.languages.list = undefined;
      Application.save($stateParams.id);
    }
      
    vm.next = function() {
      vm.save();
      $state.go('application_screen_style', { id: $stateParams.id });
	  }
  }
}


// WEBPACK FOOTER //
// ./client/app/application/storyboard/storyboard.controller.js